
import React, { useEffect, useState,useRef } from "react";
import {
  Box,
  Card,
  Typography,
  IconButton,
  Modal,
  TextField,
  Button,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";
import { BASE_URL } from "../../../components/BaseUrl";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton.js";
import mapicon from "../../../assets/Dashboard/mapicon.svg";
import empty from "../../../assets/empty.png";
import { useTranslation } from "react-i18next";
    const CompanyPerformance = ({ dateRange, onDateChange }) => {
  const { company } = useSelector((state) => state.auth);
  const companyId = company?.id;
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
    const startRef = useRef(null);
    const endRef = useRef(null);

const {t} =useTranslation()
  const [reportData, setReportData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
//   const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const [isFiltered, setIsFiltered] = useState(false);

  const [tempDateRange, setTempDateRange] = useState({ startDate: "", endDate: "" });
const [openSummaryModal, setOpenSummaryModal] = useState(false);

// function to handle open/close
const handleIcon = () => setOpenSummaryModal(true);
const handleCloseSummary = () => setOpenSummaryModal(false);
  // Get first and last day of current month
const getCurrentMonthRange = () => {
  const now = new Date();

  const first = new Date(now.getFullYear(), now.getMonth(), 1);
  const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  // format using the local timezone of the browser (no UTC shift)
  const formatLocal = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return {
    startDate: formatLocal(first),
    endDate: formatLocal(last),
  };
};

const formatDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  const date = d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  const time = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  const datePretty = date.replace(/(\d{2}\s\w{3})\s/, "$1, ");
  return `${datePretty}`;
};

const formatHours = (value) => {
  const num = parseFloat(value) || 0;
  const sign = num < 0 ? "-" : "";
  const abs = Math.abs(num);
  let hrs = Math.floor(abs);
  let mins = Math.round((abs - hrs) * 60);
  if (mins === 60) {
    hrs += 1;
    mins = 0;
  }
  return mins > 0 ? `${sign}${hrs}h ${mins}m` : `${sign}${hrs}h`;
};


useEffect(() => {
  if (companyId) {
    const defaultRange = getCurrentMonthRange();
    onDateChange && onDateChange(defaultRange); // initialize parent range
    fetchReport(defaultRange.startDate, defaultRange.endDate);
  }
}, [companyId]);
console.log("company id is",companyId)

  const fetchReport = async (start, end) => {
    try {
      const response = await fetch(`${BASE_URL}/public/reports/generate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "company_performance",
          startDate: start,
          endDate: end,
          companyId,
          showChartData: true,
        }),
      });
      const result = await response.json();
      if (!result.error) {
        setReportData(result.data.data[0]);
      }
    } catch (err) {
      console.error("Error fetching report:", err);
    }
  };

  const formatReadableDate = (dateStr) => {
    const d = new Date(dateStr);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return d.toLocaleDateString("en-US", options);
  };

  // Modal handlers
  const handleOpenModal = () => {
    setTempDateRange(dateRange);
    setOpenModal(true);
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setTempDateRange((prev) => ({ ...prev, [name]: value }));
  };

const handleApply = () => {
  setOpenModal(false);
  setIsFiltered(true);
  const newRange = {
    startDate: tempDateRange.startDate,
    endDate: tempDateRange.endDate,
  };
  onDateChange && onDateChange(newRange); // update parent
  fetchReport(newRange.startDate, newRange.endDate);
};


const handleClearFilter = () => {
  const defaultRange = getCurrentMonthRange();
  setIsFiltered(false);
  onDateChange && onDateChange(defaultRange); // reset in parent
  fetchReport(defaultRange.startDate, defaultRange.endDate);
};
const hasValidData = (data) =>
  data && data.some((item) => parseFloat(item.value) > 0);
// const hasValidData = (data) => data && data.length > 0;
if (!reportData) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "70vh",
      }}
    >
      <CircularProgress
        size={48}
        thickness={4}
        sx={{ color: "#1976d2", mb: 2 }}
      />
 
    </Box>
  );
}

  // Chart data
  const taskBarData = [
    { name: t("reportsScreen.tasksAssigned"), value: parseFloat(reportData.tasks_assigned) },
    { name: t("reportsScreen.tasksCompleted"), value: parseFloat(reportData.tasks_completed) },
    { name: t("reportsScreen.productiveTasks"), value: parseFloat(reportData.productive_tasks) },
  ];

  const performancePieData = [
    { name:t("reportsScreen.compliance"), value: parseFloat(reportData.compliance_percentage) },
    { name: t("reportsScreen.productivity"), value: parseFloat(reportData.productivity_percentage) },
    { name:t("reportsScreen.efficiency"), value: parseFloat(reportData.efficiency_percentage) },
  ];

  const COLORS = ["#42A5F5", "#66BB6A", "#FFA726"];
const BAR_COLORS = [
  "#1976D2", // Tasks Assigned
  "#4CAF50", // Tasks Completed
  "#FB8C00", // Productive Tasks
];

  return (
    <Box sx={{ p: 3 }}>
      {/* Header row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <CustomText
          sx={{
            ...textStyles.h1,
            fontWeight: 600,
            fontSize: "18px",
            color: "#003149",
          }}
        >
        {t("reportsScreen.title")}
        </CustomText>


<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  {/* Date Range Display */}
  <Box
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      px: 2,
      py: 0.8,
      fontSize: 14,
      bgcolor: "#F9FAFB",
      color: "#003149",
      textAlign: "center",
      minWidth: "230px",
    }}
  >
    {`${formatReadableDate(dateRange.startDate)} – ${formatReadableDate(
      dateRange.endDate
    )}`}
  </Box>

  {/* Filter Icon Box */}
  <Box
    sx={{
      position: "relative",
      width: 36,
      height: 36,
      borderRadius: 1,
      border: "1px solid #C4C4C4",
      bgcolor: isFiltered ? "#1976d2" : "transparent",
      color: isFiltered ? "#fff" : "#003149",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s ease",
    }}
  >
    <IconButton
      onClick={handleOpenModal}
      sx={{
        width: "100%",
        height: "100%",
        color: "inherit",
        "&:hover": {
          backgroundColor: isFiltered ? "#1565c0" : "#1976d220",
        },
      }}
    >
      <FilterAltIcon />
    </IconButton>

    {isFiltered && (
      <IconButton
        size="small"
        onClick={handleClearFilter}
        sx={{
          position: "absolute",
          top: "-5px",
          right: "-5px",
          backgroundColor: "#fff",
          border: "1px solid #C4C4C4",
          width: 18,
          height: 18,
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
      >
        <CloseIcon sx={{ fontSize: 13, color: "#333" }} />
      </IconButton>
    )}
  </Box>
</Box>


      </Box>

      {/* Charts */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "stretch",
          flexWrap: "wrap",
          gap: 3,
          mt: 2,
        }}
      >
        {/* Bar Chart */}
<Card
  sx={{
    flex: "1 1 48%",
    p: 2,
    boxShadow: "none",
    border: "2px solid #091E4224",
    borderRadius: 2,
  }}
  elevation={0}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1,
    }}
  >
    <Typography
      variant="h6"
      sx={{
        fontSize: "15px",
        color: "#44546F",
        fontWeight: 500,
        fontFamily: "Poppins, sans-serif",
      }}
    >
     {t("reportsScreen.company_task_compliance_report")}
    </Typography>
    <IconButton onClick={handleIcon}>
      <img src={mapicon} alt="map" style={{ width: 33, height: 33 }} />
    </IconButton>
  </Box>

  {hasValidData(taskBarData) ? (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={taskBarData} barCategoryGap="30%" barGap={10}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="value" radius={[5, 5, 0, 0]}>
          {taskBarData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={BAR_COLORS[index % BAR_COLORS.length]}
              stroke="#fff"
              strokeWidth={1}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  ) : (
    <Box
      sx={{
        height: 320,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={empty}
        alt="No data"
        style={{ width: 180, opacity: 0.7 }}
      />
    </Box>
  )}
</Card>


        {/* Pie Chart */}
<Card
  sx={{
    flex: "1 1 48%",
    p: 2,
    boxShadow: "none",
    border: "2px solid #091E4224",
    borderRadius: 2,
    overflow: "visible",
  }}
  elevation={0}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1,
    }}
  >
    <Typography
      variant="h6"
      sx={{
        fontSize: "15px",
        color: "#44546F",
        fontWeight: 500,
        fontFamily: "Poppins, sans-serif",
      }}
    >
  {t("reportsScreen.company_productivity_efficiency_report")}
    </Typography>
    <IconButton onClick={handleIcon}>
      <img src={mapicon} alt="map" style={{ width: 33, height: 33 }} />
    </IconButton>
  </Box>

  {hasValidData(performancePieData) ? (
    <Box
      sx={{
        "& .recharts-wrapper, & svg": { overflow: "visible" },
      }}
    >
    <ResponsiveContainer width="100%" height={320}>
      <PieChart margin={{ top: 20, right: 40, bottom: 20, left: 40 }}>
        <Pie
          data={performancePieData}
          cx="50%"
          cy="50%"
          innerRadius={75}
          outerRadius={110}
          paddingAngle={4}
          dataKey="value"
          label={({ name, percent }) =>
            `${name}: ${(percent * 100).toFixed(0)}%`
          }
        >
          {performancePieData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={COLORS[index % COLORS.length]}
              stroke="#fff"
              strokeWidth={2}
            />
          ))}
        </Pie>
        <Tooltip />
        <Legend
          verticalAlign="bottom"
          align="center"
          iconType="circle"
          iconSize={10}
        />
      </PieChart>
    </ResponsiveContainer>
    </Box>
  ) : (
    <Box
      sx={{
        height: 320,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={empty}
        alt="No data"
        style={{ width: 180, opacity: 0.7 }}
      />
    </Box>
  )}
</Card>

      </Box>

      {/* Date Filter Modal */}
  {/* Date Filter Modal */}
<Modal open={openModal} onClose={() => setOpenModal(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "white",
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
      width: 350,
    }}
  >
      <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        position: "relative",
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 500, color: "#003149", textAlign: "left",
           fontFamily: 'Poppins, sans-serif',
         }}
      >
       {t("reportsScreen.filterByDate")}
      </Typography>

      <IconButton
        onClick={() => setOpenModal(false)}
        sx={{
          position: "absolute",
          right: 0,
          top: "50%",
          transform: "translateY(-50%)",
          color: "#333",
          "&:hover": { backgroundColor: "#f0f0f0" },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>


    <div style={{ marginTop: "16px" }}>
      <label className="field_label">{t("reportsScreen.startDate")}</label>
      <input
       ref={startRef}
                onClick={() => startRef.current?.showPicker()} 
        type="date"
        name="startDate"
        className="project_input"
        value={tempDateRange.startDate}
        onChange={handleDateChange}
        style={{ width: "100%", marginTop: "6px",height:"42px" }}
      />
    </div>

    <div style={{ marginTop: "16px" }}>
      <label className="field_label">{t("reportsScreen.endDate")}</label>
      <input
       ref={endRef}
                onClick={() => endRef.current?.showPicker()} 
        type="date"
        name="endDate"
        className="project_input"
        value={tempDateRange.endDate}
        onChange={handleDateChange}
        style={{ width: "100%", marginTop: "6px",height:"42px" }}
      />
    </div>

    <Box sx={{display:"flex",justifyContent:"center",mt:2}}>
    <CustomButton label={t("reportsScreen.apply")} size='medium'     onClick={handleApply}/>
    </Box>
    <Box>
</Box>
  </Box>
</Modal>

{/* Summary Data Modal */}
<Modal open={openSummaryModal} onClose={handleCloseSummary}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "white",
      boxShadow: 24,
      p: 3,
      borderRadius: 3,
      width: 500,
      maxHeight: "80vh",
      overflowY: "auto",
      scrollbarWidth: "none", // for Firefox
      msOverflowStyle: "none", // for IE/Edge
      "&::-webkit-scrollbar": {
        display: "none", // for Chrome/Safari
      },
    }}
  >
    {/* Modal Header */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: "#003149",
          fontFamily: "Poppins, sans-serif",
        }}
      >
    {t("reportsScreen.summaryData")}
      </Typography>
      <IconButton
        onClick={handleCloseSummary}
        sx={{
          color: "#333",
          "&:hover": { backgroundColor: "#f0f0f0" },
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>

    {/* Table Container */}
    <Box
      sx={{
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      {reportData ? (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            borderRadius: "8px",
          }}
        >
          <thead>
            <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
              <th style={{ padding: "10px" }}>{t("reportsScreen.metric")}</th>
              <th style={{ padding: "10px",textAlign:'right' }}>
     {t("reportsScreen.value")}
       </th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(reportData).map(([key, value]) => (
              <tr key={key}>
                <td
                  style={{
                    padding: "8px 10px",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {t(`reportsScreen.summaryMetrics.${key}`, key.replace(/_/g, " "))}
                </td>
                <td
                  style={{
                    padding: "8px 10px",
                    borderBottom: "1px solid #eee",
                    textAlign: "right",
                  }}
                >
                  {key === "start_date" || key === "end_date"
    ? formatDateTime(value)
    : /hours/i.test(key)
    ? formatHours(value)
    : value}

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <Typography>{t("reportsScreen.noData")}</Typography>
      )}
    </Box>
  </Box>
</Modal>



    </Box>
  );
};

export default CompanyPerformance;







